"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_BOARDS = 'LOAD_BOARDS';
exports.LOAD_BOARD = 'LOAD_BOARD';
exports.CREATE_BOARD = 'CREATE_BOARD';
exports.UPDATE_BOARD = 'UPDATE_BOARD';
exports.SET_BOARD_ORGANIZATION = 'SET_BOARD_ORGANIZATION';
exports.ADD_BOARD_RELATION = 'ADD_BOARD_RELATION';
exports.REMOVE_BOARD_RELATION = 'REMOVE_BOARD_RELATION';
exports.LOAD_PROJECTS = 'LOAD_PROJECTS';
exports.LOAD_PROJECT = 'LOAD_PROJECT';
exports.CREATE_PROJECT = 'CREATE_PROJECT';
exports.UPDATE_PROJECT = 'UPDATE_PROJECT';
exports.SET_PROJECT_ORGANIZATION = 'SET_PROJECT_ORGANIZATION';
exports.ADD_PROJECT_RELATION = 'ADD_PROJECT_RELATION';
exports.REMOVE_PROJECT_RELATION = 'REMOVE_PROJECT_RELATION';
exports.LOAD_WORKITEMS = 'LOAD_WORKITEMS';
exports.LOAD_WORKITEM = 'LOAD_WORKITEM';
exports.CREATE_WORKITEM = 'CREATE_WORKITEM';
exports.UPDATE_WORKITEM = 'UPDATE_WORKITEM';
exports.SET_WORKITEM_ORGANIZATION = 'SET_WORKITEM_ORGANIZATION';
exports.ADD_WORKITEM_RELATION = 'ADD_WORKITEM_RELATION';
exports.REMOVE_WORKITEM_RELATION = 'REMOVE_WORKITEM_RELATION';